module.exports = __webpack_public_path__ + "src/assets/img/kompleks29.173570bc.jpg";